// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-3SoaN";
var _4 = "root_small-hpFNb";
var _5 = "header-3mIOY";
var _6 = "title-1pG9T";
var _7 = "icon-3Xb7K";
var _8 = "controls-r1DTe";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "root_small", _5 as "header", _6 as "title", _7 as "icon", _8 as "controls" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "root_small": _4, "header": _5, "title": _6, "icon": _7, "controls": _8 }
